import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const PT_PATHS = new Set([
    "/",
    "/about",
    "/blog",
    "/conjugation",
    "/converter",
    "/currency-converter",
    "/forgot-password",
    "/grammar",
    "/jlpt",
    "/jlpt-test-sites",
    "/kana-writing-practice",
    "/kanji-memory-quiz",
    "/kanji-roulette",
    "/kanji-quiz",
    "/kanji-writing-practice",
    "/similar-kanji",
    "/reading-practice",
    "/learning-roadmap",
    "/keyboard",
    "/lessons",
    "/login",
    "/newsletter",
    "/numbers",
    "/offline",
    "/practice",
    "/privacy-policy",
    "/profile",
    "/radicals",
    "/register",
    "/releases",
    "/saved-words",
    "/romaji-converter",
    "/speaking-practice",
    "/study-materials",
    "/translate",
    "/vocabulary",
    "/wanikani",
    "/worksheets",
]);

const PT_PATH_PREFIXES = ["/blog/", "/grammar/", "/kanji/", "/kanji-quiz/"];

export function hasPtVersion(pathname: string): boolean {
    return PT_PATHS.has(pathname) || PT_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function localizePath(path: string, language: string): string {
    if (language !== "pt" || !path.startsWith("/")) return path;
    const match = path.match(/^([^?#]*)(.*)$/);
    const pathname = match ? match[1] : path;
    const suffix = match ? match[2] : "";
    if (!hasPtVersion(pathname)) return path;
    return pathname === "/" ? `/pt${suffix}` : `/pt${pathname}${suffix}`;
}

export function isHomePath(pathname: string): boolean {
    return pathname === "/" || pathname === "/pt";
}

export function useLocalizedPath() {
    const { i18n } = useTranslation();
    const language = i18n.language;
    return useCallback((path: string) => localizePath(path, language), [language]);
}
